import hatsApi from '@/services/hatsApi'

export default {
  getTemplate (code) {
    return hatsApi().get('/system/mail-template/' + code)
  },
  saveTemplate (params) {
    return hatsApi().put('/system/mail-template/' + params.id, params)
  },
  getTemplates () {
    return hatsApi().get('/system/mail-templates/')
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/MailTemplate.js